<template>
    <div>
        <div v-if="formComponentId">
            <div v-for="(error, index) in getByNameInComponentId(formComponentId, name)" :key="index" class="mt-2 text-red text-xs">
                <p>
                    {{ error }}
                </p>
            </div>
        </div>
        <div v-else>
            <div v-for="(error, index) in getByName(name)" :key="index" class="mt-2 text-red text-xs">
                <p>
                    {{ error }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        name: String,
        formComponentId: ''
    },

    emits: ['update:status'],

    computed: {
        ...mapGetters('error', ['getByNameInComponentId', 'getByName']),

        status: function () {
            this.formComponentId
                ? this.$emit('update:status', !!this.getByNameInComponentId(this.formComponentId, this.name))
                : this.$emit('update:status', !!this.getByName(this.name));
        }
    }
};
</script>
